import { z } from "zod";
import { Role, TokenKind } from "../enums.js";
export const User = z.object({
    id: z.string().uuid(),
    email: z.string().email(),
    name: z.string(),
    role: Role,
    is_active: z.boolean(),
    receives_reports: z.boolean(),
    created_at: z.string(),
    last_login_at: z.string().nullable(),
});
export const UserSummary = User.pick({ id: true, email: true, name: true });
export const MagicLinkRequest = z.object({
    email: z.string().email(),
    client: z.enum(["web", "android"]).default("web"),
    device_name: z.string().max(120).optional(),
});
export const MagicLinkResponse = z.object({
    challenge_id: z.string().uuid(),
    /** Only present when email delivery is not configured (local dev). */
    dev_link: z.string().optional(),
    dev_code: z.string().optional(),
});
export const ExchangeRequest = z.union([
    z.object({
        token: z.string().min(16),
        client: z.enum(["web", "android"]).default("web"),
        device_name: z.string().max(120).optional(),
    }),
    z.object({
        challenge_id: z.string().uuid(),
        code: z.string().regex(/^\d{6}$/),
        client: z.enum(["web", "android"]).default("web"),
        device_name: z.string().max(120).optional(),
    }),
]);
export const InviteUserInput = z.object({
    email: z.string().email(),
    name: z.string().min(1).max(120),
    role: Role.default("member"),
});
export const UpdateUserInput = z.object({
    name: z.string().min(1).max(120).optional(),
    role: Role.optional(),
    is_active: z.boolean().optional(),
    receives_reports: z.boolean().optional(),
});
export const PersonalAccessToken = z.object({
    id: z.string().uuid(),
    name: z.string(),
    kind: TokenKind,
    token_prefix: z.string(),
    scopes: z.array(z.string()),
    last_used_at: z.string().nullable(),
    expires_at: z.string().nullable(),
    revoked_at: z.string().nullable(),
    created_at: z.string(),
});
export const CreateTokenInput = z.object({
    name: z.string().min(1).max(80),
    kind: TokenKind.default("cli"),
});
export const Preferences = z.object({
    receives_reports: z.boolean(),
    name: z.string().min(1).max(120),
});
//# sourceMappingURL=user.js.map